import { useState, useMemo, useEffect, useCallback } from "react";

import {
  Box,
  Text,
  HStack,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Heading,
  Stack,
  // useToast,
  useDisclosure,
  Tabs,
  TabList,
  TabPanel,
  TabPanels,
} from "@chakra-ui/react";

import { useHistory } from "react-router-dom";

import { ReactComponent as FilterIcon } from "assets/svg/filter.svg";

import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
// import Button from "components/Button/Button";
// import Select from "components/Select/Select";
// import Input from "components/Input/Input";
import FilterModal from "components/Modals/PartnersFilter";
import { CustomTab } from "../Cards/MyCard";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import InviteHistoryPanel from "./InviteHistoryAffiliatePanel";
import RewardHistoryAffiliatesPanel from "./RewardHistryAffiliatePanel";
import Button from "components/Button/Button";

import Emitter from "libs/Emitter";

// import {
//   useGetCoinToUsdRateQuery,
//   useGetPriceAlertByIdQuery,
//   useUpdatePriceAlertMutation,
// } from "services/rateApi";

// import constant from "config/constant";
// import toPrecision from "util/toPrecision";
// import toCoinLocale from "util/toCoinLocale";

export default function ViewAffiliates(props) {
  //   const { userData } = props;

  // const { id } = useParams();

  const searchParams = useMemo(
    () => new URLSearchParams(props.location.search),
    [props]
  );

  // const toast = useToast();
  // const loaded = useRef(false);
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [state, _setState] = useState({});

  const setState = useCallback(
    (newState) => _setState(() => ({ ...state, ...newState })),
    [state]
  );

  // console.log("SEARCH PARAMS", searchParams.get("tab"), state);

  const tabIndex = useMemo(() => {
    const map = {
      invite: 0,
      reward: 1,
      default: 0,
    };

    return map[searchParams.get("tab") ?? "default"];
  }, [searchParams]);

  const handleTabChange = (idx) => {
    setState({ tabIndex: idx });
    searchParams.set("tab", ["invite", "reward"][idx]);
    history.push(`?${searchParams.toString()}`);
  };

  useEffect(() => {
    if (searchParams.get("tab")) {
      setState({ tabIndex });
    }

    // eslint-disable-next-line
  }, [tabIndex, searchParams]);

  // const {
  //   data: alertData,
  //   isFetching,
  //   refetch,
  // } = useGetPriceAlertByIdQuery(id);
  // const [updateAlert, { isSuccess, isError, error }] =
  //   useUpdatePriceAlertMutation();

  // const { data: rate /*isFetching: isFetchingRate */ } =
  //   useGetCoinToUsdRateQuery(state?.coin, { skip: !state?.coin });

  // const alert = useMemo(() => alertData?.priceAlert, [alertData]);
  // const buyRate = useMemo(() => rate?.exchangeRate?.buy, [rate]);

  // const alertTypeLabel = useMemo(() => {
  //   const map = {
  //     price: {
  //       label: "Price",
  //       placeholder: "Enter price",
  //     },
  //     percentage: {
  //       label: "Percentage (%)",
  //       placeholder: "Enter percentage",
  //     },
  //   };

  //   return map[state?.type ?? "price"];
  // }, [state?.type]);

  //   console.log("ALERT", alert);

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   updateAlert({ ...state, id, ticker: `${state?.coin}usdt` });
  // };

  // const handleClose = () => {
  //   onClose();
  //   // _setState({ type: "price" });
  //   loaded.current = false;
  //   refetch();
  //   history.replace("/dashboard/account/pricealert");
  // };

  // const isDisabled = useMemo(
  //   () =>
  //     !(state?.coin && state?.direction && state?.price && state?.type) ||
  //     isLoading ||
  //     isFetching,
  //   [state, isLoading, isFetching]
  // );

  // const getError = (error) => {
  //   function isObj(obj) {
  //     var type = typeof obj;
  //     return type === "function" || (type === "object" && !!obj);
  //   }
  //   const value = isObj(error) ? Object.values(error)[0] : error;
  //   // console.log("ERROR VALUE", value);
  //   return value ?? "An unexpected error occurred";
  // };

  // useEffect(() => {
  //   if (isSuccess) {
  //     onOpen();
  //   }

  //   if (isError && error) {
  //     toast({
  //       position: "bottom-right",
  //       title: "Error",
  //       description: getError(error?.data?.error),
  //       status: "error",
  //       duration: 9000,
  //       isClosable: true,
  //     });
  //   }
  // }, [isSuccess, isError, error, onOpen, toast]);

  // useEffect(() => {
  //   if (alert && !loaded.current) {
  //     setState({
  //       ...alert,
  //       coin: String(alert?.ticker).split("usdt")[0],
  //       price: `${Math.abs(+alert?.price)}`,
  //     });
  //     loaded.current = true;
  //   }

  //   // eslint-disable-next-line
  // }, [alert, loaded]);

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <Box
          className="account-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 15vw)", "calc(100% - 30vw)"]}
            m="0"
            p={[0, 0, "1rem"]}
          >
            <Stack mx={["24px", 0]} mb={["24px", "32px"]}>
              <HStack w="100%" justifyContent="space-between">
                <Heading>Bitmama Partners</Heading>

                <Button onClick={onOpen}>
                  <HStack>
                    <Box boxSize="20px" as={FilterIcon} />
                    <Text>Filter</Text>
                  </HStack>
                </Button>
              </HStack>
              <Breadcrumb
                className="animate__animated animate__fadeInDown"
                separator={
                  <ArrowForwardIosRoundedIcon
                    style={{ fontSize: ".8em", color: "#6E7191" }}
                  />
                }
              >
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account">
                    Account
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/account/partners">
                    Bitmama Partners
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage to="">
                    History
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Stack>

            <Box
              bg="white"
              p={["32px 24px", "32px 24px", "40px 22px"]}
              //   mt={["24px", "10px"]}
              borderRadius={[0, "8px", "16px"]}
            >
              <Tabs
                w="100%"
                isFitted
                index={state?.tabIndex ?? 0}
                onChange={handleTabChange}
              >
                <TabList border="none" borderRadius="6px" p="6px" bg="#D9DBE9">
                  <CustomTab>Invite History</CustomTab>
                  <CustomTab>Reward History</CustomTab>
                </TabList>

                <TabPanels>
                  <TabPanel px="0">
                    <InviteHistoryPanel filters={state} />
                  </TabPanel>
                  <TabPanel px="0">
                    <RewardHistoryAffiliatesPanel filters={state} />
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </Box>
          </Container>
        </Box>
      </Box>
      {/* 
      <SuccessModal
        isOpen={isOpen}
        onClose={handleClose}
        title="Success"
        message={`Price alert successfully updated `}
      /> */}

      <FilterModal
        isOpen={isOpen}
        onClose={onClose}
        onFilter={(filter) => {
          setState({ ...filter });
          Emitter.emit("PARTNERS_VIEW_DATE_FILTER", filter);
        }}
      />
    </Box>
  );
}
